import { mods } from '@approvalmax/theme';
import { RadioGroupEditor } from '@approvalmax/ui';
import { animated } from '@react-spring/web';
import { StyledMods } from '@styled-kit/mods';
import { CheckIcon } from 'modules/sprites';
import { font } from 'modules/styles';
import styled from 'styled-components';

export const Root = styled.div`
    & .form-dropdown-editor-no-filter-button--t-form__default-no-filter-content {
        padding-top: 10px;
        padding-bottom: 10px;
    }
`;

export const Title = styled.span`
    ${font(13, '#000000', 'semibold')};

    &::after {
        content: '*';
        color: #cb4e30;
        margin-left: 3px;
    }
`;

export const GreenCheckIcon = styled(CheckIcon)`
    margin-left: auto;
    flex: none;

    & path {
        fill: green;
    }
`;

export const ListItemText = styled.div`
    min-width: 0;
    flex: auto;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ListItemWithIcon = styled.div`
    display: flex;
    align-items: center;
    padding: 6px 0;
`;

export const ListItemContent = styled.div`
    padding: 6px 0;
`;

export const StyledRadioGroupEditor = styled(RadioGroupEditor)`
    margin-top: 10px;
    margin-bottom: 15px;
`;

export const AnimatedSelectContainer = styled(animated.div as any)<StyledMods<{ withMargin?: boolean }>>`
    overflow: hidden;

    ${mods('withMargin', true)`
        margin-bottom: 10px;
    `};
`;
